import { render, staticRenderFns } from "./BinInfo.vue?vue&type=template&id=ff7f1f8e&scoped=true"
import script from "./BinInfo.vue?vue&type=script&lang=js"
export * from "./BinInfo.vue?vue&type=script&lang=js"
import style0 from "./BinInfo.vue?vue&type=style&index=0&id=ff7f1f8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7f1f8e",
  null
  
)

export default component.exports